import { log } from '@intigral/utils';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { appConfig } from '../config/app.config';
import { addUser } from '../store/reducers/userSlice';
import { setUser, storeUserInfo } from '../utils/user';
import { guestBrowseLogin } from './login';
import {
    onGuestUserSession,
    shouldRunGuestLandingBootstrap,
    clearStaleSignedInCookieWithoutLocalUser,
    clearAuthSessionCookies,
} from './session';
import { consumeGuestExploreIntent, completeGuestExploreIntent, isGuestExplorePending, captureGuestExploreFromUrl } from './exploreIntent';
import { sendUnsignedUserToLoginIfDeepLink } from '../utils/pendingDeepLink';

export function useGuestLandingBootstrap(dataDomainReady: boolean) {
    const dispatch = useDispatch();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!dataDomainReady) {
            return;
        }

        captureGuestExploreFromUrl();
        consumeGuestExploreIntent();
        clearStaleSignedInCookieWithoutLocalUser();

        if (sendUnsignedUserToLoginIfDeepLink()) {
            return;
        }

        const shouldBootstrap = isGuestExplorePending() || shouldRunGuestLandingBootstrap();

        if (!shouldBootstrap) {
            setReady(true);
            return;
        }

        let cancelled = false;
        setReady(false);

        (async () => {
            const guest = await guestBrowseLogin();
            if (cancelled) {
                return;
            }

            if (guest) {
                clearAuthSessionCookies();
                setUser(guest as unknown as Record<string, unknown>);
                dispatch(addUser(guest));
                storeUserInfo(guest as any, appConfig.userCookieExpirationDays ?? 30);
                onGuestUserSession();
                completeGuestExploreIntent();
            } else {
                log.error('[Guest] landing login failed');
            }

            setReady(true);
        })();

        return () => {
            cancelled = true;
        };
    }, [dataDomainReady, dispatch]);

    return { guestBootstrapReady: ready };
}
